import React from "react";
import useT  from '../../../Traduction';

const ValueOverview = ({ formatData, nameAlreadyExist, setFormatName, formatName }) => {
  const t = useT();
  const handleInputChangeFormatName = (event) => {
    setFormatName(event.target.value.toUpperCase());
  };
  return (
    <div>
      <h4 className="text-center mb-5">{t("General_information")}</h4>
      <div className="row">
        {Object.entries(formatData.format).map(([key, value], index) => (
          <div className="col-md-4 mb-2" key={index}>
            {key === "name" && (
              <>
                {!nameAlreadyExist ? (
                  <div>
                    <strong>{t("Format")}: </strong>{formatData.format.supplier}
                  </div>
                ) : (
                  <div className="d-flex align-items-center">
                    <strong>{t("format_name_format")}: </strong>
                    <input
                      className="form-control"
                      type="text"
                      placeholder={t("Format_name")}
                      value={formatName}
                      onChange={handleInputChangeFormatName}
                    />
                  </div>
                )}
              </>
            )}

            {key === "file_type" && (
              <div>
                <strong>{t("File_type")}:</strong> {value.toUpperCase()}
              </div>
            )}

            {key === "has_headers" && (
              <div>
                <strong>{t("Header")}:</strong> {typeof value === "boolean" ? (value ? t("Yes") : t("No")) : value}
              </div>
            )}

            {key === "finished_product" && (
              <div>
                <strong>{t("Finished_product")}:</strong> {typeof value === "boolean" ? (value ? t("Yes") : t("No")) : value}
              </div>
            )}

            {key === "fixed_field_size" && (
              <div>
                <strong>{t("Fixed_field_size")}:</strong> {typeof value === "boolean" ? (value ? t("Yes") : t("No")) : value}
              </div>
            )}

            {key === "encoding" && (
              <div>
                <strong>{t("Encoding")}:</strong> {value}
              </div>
            )}

            {formatData.format.file_type === "csv" && key === "quoting_char" && (
              <div>
                <strong>{t("Quoting_char")}:</strong> {value}
              </div>
            )}
            
            {formatData.format.file_type === "csv" && key === "separator" && (
              <div>
                <strong>{t("Separator")}:</strong> {value}
              </div>
            )}

            {key === "supplier" && (
              <div>
                <strong>{t("Supplier")}:</strong> {value}
              </div>
            )}

            {key === "country" && (
              <div>
                <strong>{t("Country")}:</strong> {value}
              </div>
            )}

            {key === "language" && (
              <div>
                <strong>{t("Language")}:</strong> {value}
              </div>
            )}

            {key === "skip_rows" && formatData.format.skip_rows && (
              <div>
                <strong>{t("Skip_rows")}:</strong> {value}
              </div>
            )}

            {key === "skip_end_rows" && formatData.format.skip_end_rows && (
              <div>
                <strong>{t("Skip_end_rows")}:</strong> {value}
              </div>
            )}

            {formatData.format.brand && key === "brand" && formatData.format.brand && (
              <div>
                <strong>{t("Brand")}:</strong> {value}
              </div>
            )}

            {key === "unit_height" && formatData.format.unit_height !== "" && (
              <div>
                <strong>{t("Unit_height")}:</strong> {value}
              </div>
            )}

            {key === "unit_length" && formatData.format.unit_length !== "" && (
              <div>
                <strong>{t("Unit_length")}:</strong> {value}
              </div>
            )}

            {key === "unit_volume" && formatData.format.unit_volume !== "" && (
              <div>
                <strong>{t("Unit_volume")}:</strong> {value}
              </div>
            )}

            {key === "unit_weight" && formatData.format.unit_weight !== "" && (
              <div>
                <strong>{t("Unit_width")}:</strong> {value}
              </div>
            )}

            {key === "unit_width" && formatData.format.unit_width !== "" && (
              <div>
                <strong>{t("Unit_width")}:</strong> {value}
              </div>
            )}
            
            {formatData.format.fixed_field_size && key === "unit_price" && (
              <div>
                <strong>{t("Unit_price")}:</strong> {t(value)}
              </div>
            )}
            
            {formatData.format.excel_sheets_all && key === "excel_sheets_all" && (
              <div>
                <strong>{t("Excel_sheets_all")}:</strong> {typeof value === "boolean" ? (value ? t("Yes") : t("No")) : value}
              </div>
            )}
            
            {formatData.format.excel_sheets_names && key === "excel_sheets_names" && formatData.format.excel_sheets_all && (
              <div>
                <strong>{t("Excel_sheets_names")}:</strong> {value}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ValueOverview;
